var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard-summary"},[_vm._v(" "+_vm._s(_vm.total)+" order(s) filtered, "),_c('auto-refresh')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }